// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../components/PlayerProfiling.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Import PlayerProfiling styles for consistency */

/* Override specific styles for password step */
.profiling-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #0877BC 0%, #065a8f 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.profiling-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  padding: 40px;
  max-width: 600px;
  width: 100%;
  text-align: center;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.profiling-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #0877BC, #065a8f);
}

/* Header styles */
.profiling-header {
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.profiling-logo {
  width: 180px;
  height: auto;
  margin-bottom: 25px;
  object-fit: contain;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2));
  transition: transform 0.3s ease, filter 0.3s ease;
  background: rgba(255, 255, 255, 0.1);
  padding: 20px;
  border-radius: 20px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  max-width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}

.profiling-logo .success-icon {
  font-size: 3rem;
  animation: bounce 1s ease-in-out;
}

.profiling-logo .loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #e1e8ed;
  border-top: 4px solid #0877BC;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.profiling-header h1 {
  color: #2d3748;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 10px;
  background: linear-gradient(135deg, #0877BC, #065a8f);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.profiling-header p {
  color: #718096;
  font-size: 1.1rem;
  margin: 0;
}

.email-display {
  background: #e8f5e8;
  color: #27ae60;
  padding: 0.5rem 1rem;
  border-radius: 10px;
  font-weight: 500;
  margin-top: 1rem;
}

/* Form styles */
.profiling-form {
  text-align: left;
}

.input-field {
  margin-bottom: 1.5rem;
}

.input-field label {
  display: block;
  margin-bottom: 0.5rem;
  color: #2c3e50;
  font-weight: 500;
  font-size: 1rem;
}

.input-field input {
  width: 100%;
  padding: 1rem;
  border: 2px solid #e1e8ed;
  border-radius: 10px;
  font-size: 1rem;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.input-field input:focus {
  outline: none;
  border-color: #0877BC;
  box-shadow: 0 0 0 3px rgba(8, 119, 188, 0.1);
}

.input-field input.error {
  border-color: #e74c3c;
  box-shadow: 0 0 0 3px rgba(231, 76, 60, 0.1);
}

.input-field input:disabled {
  background-color: #f8f9fa;
  cursor: not-allowed;
}

.error-text {
  color: #e74c3c;
  font-size: 0.875rem;
  margin-top: 0.25rem;
  display: block;
}

.general-error {
  background: #fdf2f2;
  color: #e74c3c;
  padding: 1rem;
  border-radius: 10px;
  margin-bottom: 1.5rem;
  border: 1px solid #fecaca;
  text-align: center;
}

/* Navigation styles */
.profiling-navigation {
  margin-top: 2rem;
  text-align: center;
}

.profiling-form .legal-accept {
  margin: 1.25rem 0 0.35rem;
}

.profiling-form .legal-accept + .error-text {
  display: block;
  text-align: left;
  margin-bottom: 0.5rem;
}

.next-button {
  background: linear-gradient(135deg, #0877BC 0%, #065a8f 100%);
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 10px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 200px;
}

.next-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(8, 119, 188, 0.3);
}

.next-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.secondary-button {
  background: #6c757d;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

.secondary-button:hover {
  background: #5a6268;
  transform: translateY(-1px);
}

.retry-button {
  background: #ff6b6b;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

.retry-button:hover {
  background: #ff5252;
  transform: translateY(-1px);
}

.debug-button {
  background: #28a745;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  cursor: pointer;
  font-size: 0.8rem;
  margin-right: 0.5rem;
  transition: all 0.3s ease;
}

.debug-button:hover {
  background: #218838;
  transform: translateY(-1px);
}

/* Footer styles */
.profiling-footer {
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e1e8ed;
  text-align: center;
}

.profiling-footer p {
  color: #7f8c8d;
  margin: 0;
}

.link-button {
  background: none;
  border: none;
  color: #0877BC;
  cursor: pointer;
  text-decoration: underline;
  font-size: inherit;
  padding: 0;
}

.link-button:hover {
  color: #065a8f;
}

/* Animations */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .profiling-container {
    padding: 1rem;
  }
  
  .profiling-card {
    padding: 2rem 1.5rem;
  }
  
  .profiling-header h1 {
    font-size: 1.8rem;
  }
  
  .profiling-header p {
    font-size: 1rem;
  }
  
  .profiling-logo {
    width: 120px;
    padding: 15px;
  }
  
  .profiling-logo .success-icon {
    font-size: 2rem;
  }
  
  .next-button {
    padding: 0.8rem 1.5rem;
    font-size: 1rem;
    min-width: 150px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/PasswordRegistration.css"],"names":[],"mappings":"AAAA,kDAAkD;;AAGlD,+CAA+C;AAC/C;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,4DAA4D;AAC9D;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oDAAoD;AACtD;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,iDAAiD;EACjD,iDAAiD;EACjD,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;EAC1C,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":["/* Import PlayerProfiling styles for consistency */\n@import '../components/PlayerProfiling.css';\n\n/* Override specific styles for password step */\n.profiling-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #0877BC 0%, #065a8f 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.profiling-card {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n  padding: 40px;\n  max-width: 600px;\n  width: 100%;\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.profiling-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #0877BC, #065a8f);\n}\n\n/* Header styles */\n.profiling-header {\n  margin-bottom: 30px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.profiling-logo {\n  width: 180px;\n  height: auto;\n  margin-bottom: 25px;\n  object-fit: contain;\n  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2));\n  transition: transform 0.3s ease, filter 0.3s ease;\n  background: rgba(255, 255, 255, 0.1);\n  padding: 20px;\n  border-radius: 20px;\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  max-width: 100%;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.profiling-logo .success-icon {\n  font-size: 3rem;\n  animation: bounce 1s ease-in-out;\n}\n\n.profiling-logo .loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #e1e8ed;\n  border-top: 4px solid #0877BC;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n.profiling-header h1 {\n  color: #2d3748;\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin-bottom: 10px;\n  background: linear-gradient(135deg, #0877BC, #065a8f);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.profiling-header p {\n  color: #718096;\n  font-size: 1.1rem;\n  margin: 0;\n}\n\n.email-display {\n  background: #e8f5e8;\n  color: #27ae60;\n  padding: 0.5rem 1rem;\n  border-radius: 10px;\n  font-weight: 500;\n  margin-top: 1rem;\n}\n\n/* Form styles */\n.profiling-form {\n  text-align: left;\n}\n\n.input-field {\n  margin-bottom: 1.5rem;\n}\n\n.input-field label {\n  display: block;\n  margin-bottom: 0.5rem;\n  color: #2c3e50;\n  font-weight: 500;\n  font-size: 1rem;\n}\n\n.input-field input {\n  width: 100%;\n  padding: 1rem;\n  border: 2px solid #e1e8ed;\n  border-radius: 10px;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  box-sizing: border-box;\n}\n\n.input-field input:focus {\n  outline: none;\n  border-color: #0877BC;\n  box-shadow: 0 0 0 3px rgba(8, 119, 188, 0.1);\n}\n\n.input-field input.error {\n  border-color: #e74c3c;\n  box-shadow: 0 0 0 3px rgba(231, 76, 60, 0.1);\n}\n\n.input-field input:disabled {\n  background-color: #f8f9fa;\n  cursor: not-allowed;\n}\n\n.error-text {\n  color: #e74c3c;\n  font-size: 0.875rem;\n  margin-top: 0.25rem;\n  display: block;\n}\n\n.general-error {\n  background: #fdf2f2;\n  color: #e74c3c;\n  padding: 1rem;\n  border-radius: 10px;\n  margin-bottom: 1.5rem;\n  border: 1px solid #fecaca;\n  text-align: center;\n}\n\n/* Navigation styles */\n.profiling-navigation {\n  margin-top: 2rem;\n  text-align: center;\n}\n\n.profiling-form .legal-accept {\n  margin: 1.25rem 0 0.35rem;\n}\n\n.profiling-form .legal-accept + .error-text {\n  display: block;\n  text-align: left;\n  margin-bottom: 0.5rem;\n}\n\n.next-button {\n  background: linear-gradient(135deg, #0877BC 0%, #065a8f 100%);\n  color: white;\n  border: none;\n  padding: 1rem 2rem;\n  border-radius: 10px;\n  font-size: 1.1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  min-width: 200px;\n}\n\n.next-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 20px rgba(8, 119, 188, 0.3);\n}\n\n.next-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.secondary-button {\n  background: #6c757d;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n}\n\n.secondary-button:hover {\n  background: #5a6268;\n  transform: translateY(-1px);\n}\n\n.retry-button {\n  background: #ff6b6b;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n}\n\n.retry-button:hover {\n  background: #ff5252;\n  transform: translateY(-1px);\n}\n\n.debug-button {\n  background: #28a745;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 0.8rem;\n  margin-right: 0.5rem;\n  transition: all 0.3s ease;\n}\n\n.debug-button:hover {\n  background: #218838;\n  transform: translateY(-1px);\n}\n\n/* Footer styles */\n.profiling-footer {\n  margin-top: 2rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid #e1e8ed;\n  text-align: center;\n}\n\n.profiling-footer p {\n  color: #7f8c8d;\n  margin: 0;\n}\n\n.link-button {\n  background: none;\n  border: none;\n  color: #0877BC;\n  cursor: pointer;\n  text-decoration: underline;\n  font-size: inherit;\n  padding: 0;\n}\n\n.link-button:hover {\n  color: #065a8f;\n}\n\n/* Animations */\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n@keyframes bounce {\n  0%, 20%, 50%, 80%, 100% {\n    transform: translateY(0);\n  }\n  40% {\n    transform: translateY(-10px);\n  }\n  60% {\n    transform: translateY(-5px);\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .profiling-container {\n    padding: 1rem;\n  }\n  \n  .profiling-card {\n    padding: 2rem 1.5rem;\n  }\n  \n  .profiling-header h1 {\n    font-size: 1.8rem;\n  }\n  \n  .profiling-header p {\n    font-size: 1rem;\n  }\n  \n  .profiling-logo {\n    width: 120px;\n    padding: 15px;\n  }\n  \n  .profiling-logo .success-icon {\n    font-size: 2rem;\n  }\n  \n  .next-button {\n    padding: 0.8rem 1.5rem;\n    font-size: 1rem;\n    min-width: 150px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
